export default "__VITE_PUBLIC_ASSET__878c31e1__"